import { Button, Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Cancel, FloorPlansTitle, Href, InteriorInspirations } from "../../../../../../../constants";
import { ModalSwiperSlider } from "../../../../../../../data/pages/Other";
import { AmenitiesData } from "../../../../../../../data/Property";
import { useAppDispatch, useAppSelector } from "../../../../../../../reduxToolkit/hooks";
import { setMoreDetailsModal } from "../../../../../../../reduxToolkit/reducers/layoutSlice";
import { dynamicImage, Image } from "../../../../../../../utils";
import RatioImage from "../../../../../../../utils/RatioImage";
import CloseBtn from "../../../../../../commonComponents/CloseBtn";
import Overview from "../../../../../../commonComponents/productDetail/detailBody/detailBodyItem/Overview";

const MoreDetailsModal = () => {
  const { moreDetailsModal } = useAppSelector((state) => state.layout);
  const dispatch = useAppDispatch();

  const toggle = () => dispatch(setMoreDetailsModal());
  return (
    <Modal fade centered size="xl" modalClassName="theme-modal" className="property-detail-section" isOpen={moreDetailsModal} toggle={toggle}>
      <ModalHeader toggle={toggle} close={<CloseBtn toggle={toggle} />} />
      <ModalBody className="detail-body">
        <Overview type="use_dashboard" label />
        <Row className="gy-sm-0 gy-3">
          <Col sm="8">
            <h4 className="modal-title">{InteriorInspirations}</h4>
            <Swiper className="modal-swiper-slider ratio_square" {...ModalSwiperSlider}>
              {AmenitiesData.map((item, index) => (
                <SwiperSlide key={index}>
                  <a href={Href}>
                    <RatioImage src={dynamicImage(`property/${item.image}.jpg`)} alt="modal-img" className="bg-img" />
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>
          </Col>
          <Col sm="4">
            <h4 className="modal-title">{FloorPlansTitle}</h4>
            <div className="floor-plan">
              <Image src={dynamicImage("property/detail/floor.png")} alt="floor-plan" className="img-fluid" />
            </div>
          </Col>
        </Row>
        <div className="d-flex align-items-center justify-content-end gap-2 mt-4">
          <Button className="btn-solid" onClick={toggle}>
            {Cancel}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default MoreDetailsModal;
